<template>
  <div class="sms-left" :style="style">
    <div class="sms-left-header pa-3">
      <group-message></group-message>
      <v-text-field
        outlined
        dense
        v-model.trim="search"
        placeholder="Search by Name"
        prepend-inner-icon="mdi-magnify"
      >
      </v-text-field>
    </div>
    <v-divider></v-divider>
    <v-list class="pa-0 sms-left-list">
      <template v-for="(item, i) in list">
        <v-list-item
          link
          :key="i"
          :class="isActive(item) ? 'primary' : ''"
          :dark="isActive(item)"
          @click="click(item)"
        >
          <v-list-item-content>
            <v-list-item-title class="d-flex subtitle-2">
              <span class="flex-grow-1 text-capitalize">
                {{ item.name }}
              </span>
            </v-list-item-title>
            <v-list-item-subtitle
              class="body-2"
              v-text="item.text ? item.text : '-'"
            ></v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action class="d-flex ml-1">
            <span class="caption pl-1">
              {{ $root.timeago(item.chat_at) }}
            </span>
            <v-btn
              icon
              color="red"
              x-small
              @click="remove(item, i)"
              v-if="isAdmin"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider :key="'divider' + i"></v-divider>
      </template>
    </v-list>
    <confirm-delete ref="confirm"></confirm-delete>
  </div>
</template>

<script>
import GroupMessage from "./GroupMessage.vue";
import ConfirmDelete from "../sms/ConfirmDelete.vue";
export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    GroupMessage,
    ConfirmDelete
  },
  data() {
    return {
      lastDoc: null,
      active: {},
      search: "",
      unsubscribe: null,
      isMobile: window.innerWidth < 768
    };
  },
  watch: {
    value(val) {
      this.active = val;
    },
    shouldRerender() {
      // Your re-render logic here
      const data = this.$store.state.shouldRerenderLeftComponent
      const index = this.list.findIndex(row => row.id == data.id)
      this.list[index].name = data.name
    }
  },
  computed: {
    list() {
      let list = this.$store.getters.technicians.filter(item => {
        return item.chat_at != undefined;
      });
      list = list.sort((a, b) => {
        let date = new Date(new Date().setFullYear(1990));
        if (!a.chat_at) a.chat_at = date;
        if (!b.chat_at) b.chat_at = date;
        return new Date(b.chat_at) - new Date(a.chat_at);
      });
      return list.filter(item => {
        let name = item.name.toLowerCase();
        let search = this.search.toLowerCase();
        if (search) {
          return name.startsWith(search);
        } else {
          return item;
        }
      });
    },
    style() {
      return {
        width: this.isMobile ? "100%" : "350px",
        borderWidth: this.isMobile ? "0px" : "1px"
      };
    },
    shouldRerender() {
      return this.$store.state.shouldRerenderLeftComponent;
    }
  },
  methods: {
    remove({ id }, i) {
      const vm = this;
      vm.$refs.confirm.init(id, i, "technician");
    },

    isActive({ id }) {
      return this.active.id === id;
    },
    click(item) {
      const vm = this;
      if (vm.isMobile) {
        vm.$router.push({
          path: `/technician-sms-view/${item.id}`,
          query: {
            name: item.name,
            phone: item.phone
          }
        });
      } else {
        vm.$router.push({
          path: `/technician-sms`,
          query: {
            id: item.id,
            name: item.name,
            phone: item.phone
          }
        });
      }
    },
    init() {
      if (this.list[0]) {
        this.$emit("init", this.list[0]);
      }
    }
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    if (this.unsubscribe !== null) this.unsubscribe();
  }
};
</script>

<style lang="scss">
.sms-left {
  width: 350px;
  background: white;
  height: calc(100vh - 67px);
  border-right: 1px solid lightgray;
  &-header {
    height: 100px;
  }
  &-list {
    height: calc(100vh - 168px);
    overflow-y: auto;
  }
}
</style>
